import isBefore from 'date-fns/isBefore'
import parseISO from 'date-fns/parseISO'

import { i18n } from '../lang'
import {
  FormRules,
  // countryList, ServerToFormData, FormToServerFormat,
} from '../utils/form'

export const userTypes = [
  // { label: 'Member', value: 'member' },
  // { label: 'Guest', value: 'guest' },
  { label: 'member_87', value: 'member_87' },
  { label: 'goxiptest', value: 'goxiptest' },
]
if (process.env.NODE_ENV === 'production') {
  userTypes.unshift({ label: 'All', value: 'all' })
}

export const pushNotificationTargetGroups = [
  { label: 'All Users', value: 'all' },
  { label: 'Member Only', value: 'member' },
  { label: 'Staff Only', value: 'member_87' },
]
export const pushNotificationTargetGroupsMap = new Map([
  ['all', 'All Users'],
  ['member', 'Member Only'],
  ['member_87', 'Staff Only'],
  ['goxiptest', 'Goxip Test'],
  ['guest', 'Guest Only'],
  ['all_zh_hk', 'All Users (zh-Hant)'],
  ['all_en', 'All Users (en)'],
])

export const pushNotificationsColumnList = [
  { type: 'id', custom: { width: 50 } },
  { type: 'scheduled_at', title: `${i18n.t('table.target_push_time')} (HKT)`, custom: { width: 160 } },
  { type: 'message' },
  { type: 'target_id', title: i18n.t('table.banner_id'), custom: { width: 100 } },
  { type: 'topic', title: i18n.t('table.channel'), custom: { width: 140 } },
  { type: 'success_device_count', title: i18n.t('table.successful_deliveries'), custom: { width: 90 } },
  { type: 'created_at', title: `${i18n.t('table.created_at')} (HKT)`, custom: { width: 150 } },
]

export const getDefaultPushNotificationDetail = () => ({
  target_id: null,
  topic: null,
  message: '',
  message_zh_hk: '',
  scheduled_at: null,
  utm_params: 'utm_source=wb&utm_medium=org&utm_campaign=191211_botactivity-push-app-generic_wb&utm_salescode=191211bwbmggoxmbndpush',
})

const validateCustomTime = (rule, value, callback) => {
  if (!value) {
    return callback()
  } else if (isBefore(parseISO(value), new Date())) {
    return callback(new Error('Selected date is in the past.'))
  }
  return callback()
}
const formRules = {
  required: [FormRules.required],
  requiredChange: [FormRules.requiredChange],
  targetPushTime: [{ required: true, validator: validateCustomTime, trigger: 'blur' }],
  id: [FormRules.required, FormRules.id],
  countries: [FormRules.requiredCountries],
}
export const pushNotificationFormTemplate = [
  {
    key: 'message',
    isEmojiPicker: true,
    isSlot: true,
    rules: formRules.requiredChange,
  },
  {
    key: 'message_zh_hk',
    isEmojiPicker: true,
    isSlot: true,
    rules: formRules.requiredChange,
  },
  {
    key: 'scheduled_at',
    title: i18n.t('table.target_push_time'),
    isDatePicker: true,
    rules: formRules.targetPushTime,
    type: 'datetime',
    custom: {
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
    },
  },
  {
    key: 'target_id',
    title: i18n.t('table.banner_id'),
    isInput: true,
    rules: formRules.id,
  },
  {
    key: 'topic',
    isSelect: true,
    list: userTypes,
    title: i18n.t('table.channel'),
    rules: formRules.required,
  },
  {
    key: 'utm_params',
    title: i18n.t('table.utm_params'),
    isInput: true,
  },
  // {
  //   key: 'countries',
  //   isCheckbox: true,
  //   title: i18n.t('table.availableCountries'),
  //   list: countryList,
  //   rules: formRules.countries,
  // },
]
